import { CloudIcon, ServerIcon } from "lucide-react";

import type { ThreadOrigin } from "./threadOrigin";

/**
 * The canonical WHERE glyph for a thread. Every surface that marks a thread's
 * location renders this, so a row and its own hover tooltip cannot disagree
 * about the same thread — which they did while the row derived a lone
 * ServerIcon from one boolean and the tooltip split cloud from machine.
 *
 * `current-device` renders nothing at all, and that is the point: a badge on
 * every row carries no information. Upstream t3code gates its glyph the same
 * way, on `isRemote`.
 */
export function ThreadOriginIcon(props: {
  readonly origin: ThreadOrigin;
  readonly className?: string;
}) {
  if (props.origin === "current-device") return null;

  const Glyph = props.origin === "cloud" ? CloudIcon : ServerIcon;
  return (
    <span
      className="inline-flex shrink-0 items-center text-sidebar-muted-foreground/70"
      data-thread-origin={props.origin}
    >
      <Glyph aria-hidden className={props.className} />
    </span>
  );
}
